var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

import React, { PureComponent, createElement } from 'react';
import { Layout, Icon } from 'antd';
import classNames from 'classnames';
import { FlexLayout } from '../flex-layout';
import { Breadcrumb } from '../breadcrumb';
import { ComponentsManager } from '@comall-backend-builder/core';
import { extendsParentProps } from '../component-props';
import { services } from '@comall-backend-builder/core';
var Header = Layout.Header,
    Footer = Layout.Footer,
    Sider = Layout.Sider,
    Content = Layout.Content;
var DEFAULT_PROPS = {
  'side-nav': {
    sider: {
      collapsible: true
    },
    header: {},
    breadcrumb: {},
    content: {},
    footer: {}
  },
  'top-nav': {
    sider: {},
    header: {},
    breadcrumb: {},
    content: {},
    footer: {}
  },
  'pro-style-nav': {
    sider: {
      collapsible: true
    },
    header: {},
    breadcrumb: {},
    content: {},
    footer: {}
  }
};

var Frame = function (_super) {
  __extends(Frame, _super);

  function Frame(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      collapsed: false
    };
    _this.toggleCollapse = _this.toggleCollapse.bind(_this);
    return _this;
  }

  Frame.prototype.toggleCollapse = function () {
    this.setState({
      collapsed: !this.state.collapsed
    });
  };

  Frame.prototype.renderItems = function (items, extraProps) {
    var _this = this;

    if (!items) {
      return;
    }

    return items.map(function (itemDesc, index) {
      var component = itemDesc.component,
          otherProps = __rest(itemDesc, ["component"]);

      if (itemDesc.privilege) {
        var _a = itemDesc.privilege,
            path = _a.path,
            level = _a.level;

        if (!services.privilege.check(path, level)) {
          return undefined;
        }
      }

      var ItemComponent = ComponentsManager.get(component);
      var itemProps = extendsParentProps(__assign(__assign(__assign({}, otherProps), {
        key: index
      }), extraProps), _this.props);
      return createElement(ItemComponent, itemProps);
    });
  };

  Frame.prototype.render = function () {
    var collapsed = this.state.collapsed;

    var _a = this.props,
        type = _a.type,
        className = _a.className,
        style = _a.style,
        header = _a.header,
        _b = _a.sider,
        _c = _b === void 0 ? {
      fixed: undefined
    } : _b,
        siderFixed = _c.fixed,
        sider = __rest(_c, ["fixed"]),
        breadcrumb = _a.breadcrumb,
        content = _a.content,
        footer = _a.footer,
        routes = _a.routes;

    var headerProps = __assign(__assign({}, DEFAULT_PROPS[type].header), header);

    var headerFlexProps = extendsParentProps({
      direction: 'horizontal',
      align: 'center',
      justify: 'justify',
      items: headerProps.items || []
    }, this.props);
    delete headerProps.items;

    var siderProps = __assign(__assign({}, DEFAULT_PROPS[type].sider), sider);

    var contentLayoutStyle;

    if (siderFixed) {
      siderProps.className = classNames(siderProps.className, 'fixed');
      contentLayoutStyle = {
        width: '100%',
        paddingLeft: collapsed ? 80 : siderProps.width || 200,
        transition: 'padding .2s'
      };
    }

    var breadcrumbProps = extendsParentProps(__assign(__assign(__assign({}, DEFAULT_PROPS[type].breadcrumb), breadcrumb), {
      routes: routes
    }), this.props);

    var contentProps = __assign(__assign({}, DEFAULT_PROPS[type].content), content);

    var contentItems = this.renderItems(contentProps.items);
    delete contentProps.items;

    var footerProps = __assign(__assign({}, DEFAULT_PROPS[type].footer), footer);

    var footerItems = this.renderItems(footerProps.items);
    delete footerProps.items;

    if (type === 'side-nav') {
      headerFlexProps.items = __spreadArrays([__assign({
        component: 'Breadcrumb'
      }, breadcrumbProps)], headerFlexProps.items);
      siderProps.collapsed = collapsed;
      siderProps.onCollapse = this.toggleCollapse;
      return React.createElement(Layout, {
        className: classNames('frame-side-nav', className),
        style: style
      }, React.createElement(Sider, __assign({}, siderProps), this.renderItems(siderProps.items, {
        collapsed: collapsed
      })), React.createElement(Layout, {
        style: contentLayoutStyle
      }, React.createElement(Header, __assign({}, headerProps), React.createElement(FlexLayout, __assign({}, headerFlexProps))), React.createElement(Content, __assign({}, contentProps), contentItems), React.createElement(Footer, __assign({}, footerProps), footerItems)));
    }

    if (type === 'top-nav') {
      return React.createElement(Layout, {
        className: classNames('frame-top-nav', className),
        style: style
      }, React.createElement(Header, __assign({}, headerProps), React.createElement(FlexLayout, __assign({}, headerFlexProps))), React.createElement(Layout, null, React.createElement(Breadcrumb, __assign({}, breadcrumbProps)), React.createElement(Content, __assign({}, contentProps), contentItems), React.createElement(Footer, __assign({}, footerProps), footerItems)));
    }

    if (type === 'pro-style-nav') {
      var ProStyleSiderProps = __assign({
        collapsed: collapsed,
        trigger: null
      }, siderProps);

      var toggleButtonProps = __assign({
        collapsed: collapsed,
        toggleCollapse: this.toggleCollapse
      }, this.props);

      headerFlexProps.justify = headerProps.justify || 'end';
      headerFlexProps.style = __assign({
        flex: '1 1 auto',
        msFlex: '1 1 auto'
      }, headerFlexProps.style);
      return React.createElement(Layout, {
        className: classNames('frame-pro-style-nav', className),
        style: style
      }, React.createElement(Sider, __assign({}, ProStyleSiderProps), this.renderItems(siderProps.items, {
        collapsed: collapsed
      })), React.createElement(Layout, {
        style: contentLayoutStyle
      }, React.createElement(Header, __assign({}, headerProps), React.createElement(ToggleButton, __assign({}, toggleButtonProps)), React.createElement(FlexLayout, __assign({}, headerFlexProps))), React.createElement(Content, __assign({}, contentProps), contentItems), React.createElement(Footer, __assign({}, footerProps), footerItems)));
    }

    return null;
  };

  return Frame;
}(PureComponent);

export { Frame };

var ToggleButton = function (_super) {
  __extends(ToggleButton, _super);

  function ToggleButton() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ToggleButton.prototype.render = function () {
    var _a = this.props,
        collapsed = _a.collapsed,
        toggleCollapse = _a.toggleCollapse,
        className = _a.className,
        style = _a.style;
    return React.createElement(Icon, {
      className: classNames('trigger', className),
      type: collapsed ? 'menu-unfold' : 'menu-fold',
      onClick: toggleCollapse,
      style: style
    });
  };

  return ToggleButton;
}(PureComponent);

export { ToggleButton };